import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { formatNumber } from '../../dwriUtils';
import '../../dwri.css';

const DwriPeakMonthAvgDemand = ({ rows = [], loading, error }) => {
    if (error) return <p className="text-danger">Error loading Peak Month Average Demand</p>;
    if (loading) return <p>Loading...</p>;

    const sortedRows = [...rows].sort((a, b) => b.year - a.year);

    return (
        <>
            <Row>
                <Col><span><b>Peak Month Average Demand</b></span></Col>
            </Row>
            <div className="table-responsive">
                <Row className='dwri-peak-month-header gx-0'>
                    <Col className='dwri-table-header-cell'><span><b>Year</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Peak Month Avg</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Peak Month Avg/ERC</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Ratio of PD/ERC Month Avg/ERC</b></span></Col>
                </Row>
                {sortedRows.map((row, index) => (
                    <Row key={row.year} className={`dwri-peak-month-row gx-0 ${index % 2 === 0 ? 'is-even' : 'is-odd'}`}>
                        <Col className='dwri-table-cell'><span>{row.year}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatNumber(row.peakMonthAvgGallons)}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatNumber(row.peakMonthAvgPerErcGallons)}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatNumber(row.ratioPeakDayErcPerPeakMonthAvgErc)}</span></Col>
                    </Row>
                ))}
            </div>
            <br />
        </>
    );
};

export default DwriPeakMonthAvgDemand;
